<template>
  <div class="tagMag">
    <el-table :data="tableList" class="tableList">
      <el-table-column
        align="center"
        prop="labelId"
        label="标签ID"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="labelTypeName"
        label="标签类型"
      ></el-table-column>
      <el-table-column prop="labelName" label="标签名称"></el-table-column>
      <el-table-column
        prop="remark"
        show-overflow-tooltip
        label="备注"
      ></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div class="btnGroup">
            <span class="table__list__btn" @click="editDialog(scope.row)"  v-show="menusList.indexOf('LABEL_MANAGE_MODIFY')!='-1'">
              编辑
            </span>
            <span class="table__list__btn" @click="onDelete(scope.row)" v-show="menusList.indexOf('LABEL_MANAGE_DELETE')!='-1'">
              删除
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="page"
        :page-size="sizePage"
        layout="total,prev, pager, next, jumper"
        :total="totalSum"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="新增标签"
      width="30%"
      :visible.sync="dialog"
      class="onDialog"
      :close-on-click-modal="false"
      :top="'20vh'"
    >
      <el-form
        label-width="90px"
        :model="data"
        :rules="rules"
        ref="form"
        class="onDialog__form"
      >
        <el-form-item label="标签类型" prop="labelTypeId">
          <el-select
            size="large"
            v-model="data.labelTypeId"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in typeList"
              :key="item.labelTypeId"
              :label="item.labelTypeName"
              :value="item.labelTypeId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签名称" prop="labelName">
          <el-input v-model="data.labelName" size="large"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="data.remark"
            size="large"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="dialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
export default {
  name: "tagType",
  data() {
    return {
      dialog: false,
      action: "",
      data: {
        id: "",
        labelTypeId: "",
        labelName: "",
        remark: "",
      },
      typeList: [],
      rules: {
        labelName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        labelTypeId: [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
      },

      page: 1,
      sizePage: 10,
      totalSum: 0,
      tableList: [],
      menusList: [],
    };
  },
  methods: {
    addDialog() {
      this.action = "add";
      this.data.labelTypeId = null;
      this.data.remark = "";
      this.data.labelName = "";
      this.dialog = true;
    },
    confirm() {
      this.$refs.form.validate((val) => {
        if (val) {
          if (this.action == "add") {
            Axios.ajax({
              url: "/label/add",
              method: "post",
              data: {
                labelName: this.data.labelName,
                labelTypeId: this.data.labelTypeId,
                remark: this.data.remark,
              },
            }).then((res) => {
              this.dialog = false;
              this.queryTableList();
              if (res.resultCode == 0) {
                this.$message.success("新增成功！");
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          } else {
            Axios.ajax({
              url: "/label/edit",
              method: "post",
              data: {
                labelId: this.data.id,
                labelTypeId: this.data.labelTypeId,
                labelName: this.data.labelName,
                remark: this.data.remark,
              },
            }).then((res) => {
              this.dialog = false;
              this.queryTableList();
              if (res.resultCode == 0) {
                this.$message.success("编辑成功！");
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          }
        }
      });
    },
    editDialog(row) {
      this.dialog = true;
      this.data.id = row.labelId;
      this.action = "edit";
      this.data.labelName = row.labelName;
      this.data.labelTypeId = row.labelTypeId;
      this.data.remark = row.remark;
    },
    onDelete(row) {
      Axios.ajax({
        url: "/label/delete",
        method: "post",
        data: {
          labelId: row.labelId,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.$message.success("删除成功！");
        } else {
          this.$message.warning(res.resultMessage);
        }
        this.queryTableList();
      });
    },
    queryTableList() {
      Axios.ajax({
        url: "/label/list",
        method: "get",
        params: {
          pageNum: this.page,
          showNum: this.sizePage,
        },
      }).then(({ data }) => {
        this.tableList = data.dataList;
        this.totalSum = data.totalNum;
      });
    },
    queryTypeList() {
      Axios.ajax({
        url: "/labelType/list",
        method: "get",
      }).then(({ data }) => {
        this.typeList = data;
      });
    },
    pageChange(val) {
      this.page = val;
      this.queryTableList();
    },
  },
  mounted() {
    this.menusList=Vue.prototype.menusList

  },
  created() {
    this.queryTableList();
    this.queryTypeList();
  },
};
</script>

<style lang="less" scoped>
.tagMag {
  height: 67.5vh;
  position: relative;
  .tableList {
    height: 90%;
    overflow: hidden;
  }
  .btnGroup {
    cursor: pointer;
    color: #2a62ff;
    font-weight: normal;
    .table__list__btn {
      margin: 0 5px;
    }
  }
  .page {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.onDialog {
  &__form {
    padding: 0 30px;
  }
}
</style>
<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
